import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {
    PROGRESS_NBN_MISSED,
    PROGRESS_NBN_TECHNICIAN,
    PROGRESS_NBN_TECHNICIAN_APPOINTMENT,
    PROGRESS_SERVICE_ACTIVE,
    PROGRESS_SETUP_MODEM,
    PROGRESS_TRACK_MODEM
} from "../constants";
import {connect} from "react-redux";
import {getCustomer} from "../redux/actions";
import BookingCalendar from "./BookingCalendar";
import moment from 'moment-timezone'
import DataSource from "../DataSource";
import LoadingOverlay from "./LoadingOverlay";
import Error from "./Error";

const ProgressTrackerRowsBroadband = ({ data, serviceDetails, getCustomer }) => {

    const [isCalendarOpen, setIsCalendarOpen] = useState(false)
    const [availableRescheduleTimeSlots, setAvailableRescheduleTimeSlots] = useState([])
    const [activeSlot, setActiveSlot] = useState()
    const [isSuccess, setIsSuccess] = useState(false)
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const formatSlots = slots => {
        const data = {}
        slots.forEach(item => {
            const date = item.start_time.split(' ')[0]
            if (data[date]) {
                data[date].slots.push(item)
            } else {
                data[date] = {
                    slotId: item.id,
                    slots: [item],
                }
            }
        })
        return data
    }

    const getAvailableSlots = () => {
        setIsLoading(true)
        setError(null)
        DataSource.getAvailableTechnicianDates(serviceDetails.serviceId, moment().tz('Australia/Sydney').format('YYYY-MM-DD'), response => {
            if (response.data && response.data.data) {
                const data = response.data.data;
                if (data.reschedules && data.reschedules.slots && data.reschedules.slots.length > 0) {
                    setAvailableRescheduleTimeSlots(formatSlots(data.reschedules.slots))
                }
                setActiveSlot(data.active_slot)
                setIsLoading(false)
            } else {
                setIsLoading(false)
                setError({error : 'We cannot currently reschedule appointment times online for this order. If you need to reschedule, please call us on 13 39 38.'})
            }
        }, (error) => {
            if (error.response && error.response.status === 422) {
                if (error.response.data && error.response.data.errors) {
                    setError(error.response.data.errors)
                } else {
                    setError({error: 'Reschedule currently unavailable for this service, please wait a few minutes and try again.'})
                }
            } else {
                setError({error: 'Oops, something went wrong. Please try again shortly or cal us on 13 39 38.'})
            }
            setIsLoading(false)
        })
    }

    const handleToggleCalendar = () => {
        if (!isCalendarOpen) {
            getAvailableSlots()
        }
        setIsCalendarOpen(!isCalendarOpen)
    }

    const RowActiveTextOnly = ({ item }) => {
        return (
            <div className="d-flex">
                <div className="icon-col">
                    <img src="/images/icon-progress-active.svg" alt="Active" />
                    <div className="line" />
                </div>
                <div className="main-col">
                    <p className="m-0 mb-2 mb-md-3 bold color-indigo">{item.title}</p>
                    <p className="m-0 mb-3 d-md-none color-indigo">{item.date}</p>
                    <div className="d-flex align-items-md-center">
                        {item.hasError ? <IconWarning /> : ''}
                        <p className='m-0' style={{whiteSpace: 'pre-wrap'}} dangerouslySetInnerHTML={{__html: item.description ? item.description: ''}} />
                    </div>
                    {item.type === PROGRESS_SETUP_MODEM && <a href={serviceDetails.modemSetupGuide} className="btn-secondary-light-small mt-4">Get started now</a>}
                    {item.type === PROGRESS_TRACK_MODEM && <a href={serviceDetails.modemTrackingUrl} className="btn-secondary-light-small mt-4">Track your order here</a>}
                </div>
                <div className="date-col color-indigo">
                    {item.date}
                </div>
            </div>
        )
    }

    const RowInactiveTextOnly = ({ item }) => {
        return (
            <div className="d-flex">
                <div className="icon-col">
                    <img src="/images/icon-progress-inactive.svg" alt="Inative" />
                </div>
                <div className="main-col d-flex align-items-center">
                    <p className="m-0 bold color-greyish">{item.title}</p>
                </div>
                <div className="date-col" />
            </div>
        )
    }

    const RowServiceActivated = ({ item }) => {
        return (
            <div className="d-flex">
                <div className="icon-col">
                    <img src="/images/icon-progress-activated.svg" alt="Active" />
                    <div className="line" />
                </div>
                <div className="main-col">
                    <p className="m-0 mb-2 mb-md-3 bold color-green-500">{item.title}</p>
                    <p className="m-0 mb-3 d-md-none color-indigo">{item.date}</p>
                    <div className="d-flex">
                        <div className="mr-2">
                            <IconInfo />
                        </div>
                        <p className='m-0 mt-1'>Explore our modem setup guides for detailed, step-by-step instructions on configuring your modem. </p>
                    </div>
                    <a href={serviceDetails.modemSetupGuide} className="btn-secondary-light-small mt-4 mb-4">Get started now</a>
                    <div className="d-flex mb-4">
                        <div className="mr-2">
                            <IconInfo />
                        </div>
                        <p className='m-0 mt-1'>Don't forget to disconnect your old internet service to avoid unwanted charges.</p>
                    </div>
                    <div className="d-flex">
                        <div className="mr-2">
                            <IconHeadphones />
                        </div>
                        <div>
                            <p className="bold mt-0 mb-2 color-indigo">We’re here to help</p>
                            <p className='m-0'>If you're still without internet, please contact our customer support team, and we'll assist you in getting connected.</p>
                        </div>
                    </div>
                    <a href="tel:133938" className="btn-secondary-light-small mt-4">Call 13 39 38</a>
                </div>
                <div className="date-col color-indigo">
                    {item.date}
                </div>
            </div>
        )
    }

    const RowNbnTechnician = ({ item }) => {
        return (
            <React.Fragment>
                <div className="d-flex position-relative">
                    <div className="icon-col">
                        <img src="/images/icon-progress-active.svg" alt="Active" />
                        <div className="line" />
                    </div>
                    <div className="main-col">
                        <p className="m-0 mb-2 mb-md-3 bold color-indigo">{item.title}</p>
                        <p className="m-0 mb-3 d-md-none color-indigo">{item.date}</p>
                        <React.Fragment>
                            {isSuccess ? <div className='bg-green py-2'>
                                <p className='bold text-center white'>Your rescheduled appointment request has been acknowledged, you will receive a confirmation of the time and date via email/SMS</p>
                            </div> : <React.Fragment>
                                <div className="d-flex align-items-start mb-4">
                                    <img src="/images/icon-technician.svg" alt="Technician" className="mr-2" />
                                    <div>
                                        {activeSlot && (
                                            <React.Fragment>
                                                <p className='mt-1 mb-4'>Your appointment is on</p>
                                                <p className={`mt-0 mb-2 bold ${item.type === PROGRESS_NBN_MISSED ? 'color-red' : ''}`}>{moment(activeSlot.start_time).format('Do MMMM YYYY')} | {moment(activeSlot.start_time).format('hh:mma')} - {moment(activeSlot.end_time).format('hh:mma')}</p>
                                            </React.Fragment>
                                        )}
                                        <p className={`m-0 ${item.type === PROGRESS_NBN_MISSED ? 'color-red' : ''}`}>{item.type === PROGRESS_NBN_MISSED && !item.completed ? 'You missed your appointment with the nbn technician. Please select a new appointment time below.' : 'You will receive an SMS reminder two days before your appointment.'}</p>
                                    </div>
                                </div>
                                <div className="d-none d-lg-block">
                                    <CalendarBlock />
                                </div>
                            </React.Fragment>}

                        </React.Fragment>
                    </div>
                    <div className="date-col color-indigo date-col-absolute">
                        {item.date}
                    </div>
                </div>
                <div className="d-lg-none">
                    <CalendarBlock />
                </div>
            </React.Fragment>
        )
    }

    const CalendarBlock = () => {
        return (
            <React.Fragment>
                <div className={`calendar-banner ${isCalendarOpen ? 'active' : ''}`} onClick={handleToggleCalendar}>
                    <div>
                        <p className="title m-0 mb-2">Not the right time?</p>
                        <p className="sub-title m-0">Reschedule your appointment.</p>
                    </div>
                    <div className="flex-grow-1 text-right">
                        <button className="btn-link down-icon">
                            <img src="/images/icon-down-white.svg" alt="Icon" />
                        </button>
                    </div>
                </div>
                {isCalendarOpen && (
                    <div className="calendar-wrap">
                        <LoadingOverlay isLoading={isLoading}>
                            {error ? (
                                <Error errors={error} />
                            ) : (
                                <BookingCalendar
                                    availableDates={availableRescheduleTimeSlots}
                                    handleCancel={handleToggleCalendar}
                                    setIsSuccess={setIsSuccess}
                                    serviceDetails={serviceDetails}
                                />
                            )}
                        </LoadingOverlay>
                    </div>
                )}
            </React.Fragment>
        )
    }

    // Unsure when this block will show.
    const ReachedMaximumRescheduleChanges = () => {
        return (
            <React.Fragment>
                {isCalendarOpen && (
                    <div className="calendar-wrap">
                        <div className="d-flex">
                            <IconWarning />
                            <div>
                                <p className="bold">
                                    You've reached the maximum number of appointment changes
                                </p>
                                <p>
                                    Please contact our customer support team for further assistance.
                                </p>
                            </div>
                        </div>
                        <div className="d-flex mt-5">
                            <a href="tel:133938" className="btn-secondary-light-small mt-4">Call 13 39 38</a>
                            <a href="tel:133938" className="btn-secondary-light-small mt-4">Live Chat</a>
                        </div>
                    </div>
                )}
            </React.Fragment>
        )
    }

    return (
        <div className="progress-tracker-rows progress-tracker-rows-broadband">
            {data.map((item, key) => {
                if (item.type === PROGRESS_NBN_TECHNICIAN || item.type === PROGRESS_NBN_MISSED || item.type === PROGRESS_NBN_TECHNICIAN_APPOINTMENT && item.completed) {
                    return <RowNbnTechnician key={key} item={item} />
                } else if (item.type === PROGRESS_SERVICE_ACTIVE && item.completed) {
                    return <RowServiceActivated item={item} />
                } else if (item.completed) {
                    return <RowActiveTextOnly key={key} item={item} />
                } else {
                    return <RowInactiveTextOnly key={key} item={item} />
                }
            })}
        </div>
    )

}

const IconWarning = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="mr-2">
            <path fillRule="evenodd" clipRule="evenodd" d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11.2 13.6V7.2H12.8V13.6H11.2ZM11.2 15.2H12.8V16.8H11.2V15.2Z" fill="#D3354A"/>
        </svg>
    )
}

const IconInfo = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 9.27273C12.5021 9.27273 12.9091 9.67974 12.9091 10.1818V16.5455C12.9091 17.0475 12.5021 17.4545 12 17.4545C11.4979 17.4545 11.0909 17.0475 11.0909 16.5455V10.1818C11.0909 9.67974 11.4979 9.27273 12 9.27273Z" fill="#004346"/>
            <path d="M12 8.36364C12.5021 8.36364 12.9091 7.95662 12.9091 7.45455C12.9091 6.95247 12.5021 6.54545 12 6.54545C11.4979 6.54545 11.0909 6.95247 11.0909 7.45455C11.0909 7.95662 11.4979 8.36364 12 8.36364Z" fill="#004346"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20.1818C16.5187 20.1818 20.1818 16.5187 20.1818 12C20.1818 7.48131 16.5187 3.81818 12 3.81818C7.48131 3.81818 3.81818 7.48131 3.81818 12C3.81818 16.5187 7.48131 20.1818 12 20.1818Z" fill="#004346"/>
        </svg>
    )
}

const IconHeadphones = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M19.1764 7.99132H19.0011C18.8146 7.98802 18.6288 8.01446 18.45 8.07002C18.45 5.53521 15.2642 3 11.7568 3C8.24928 3 5.54834 6.5493 5.54834 8.07042C5.37277 8.01533 5.18992 7.98874 5.00662 7.99125H4.82514C4.34284 7.98779 3.8789 8.18406 3.53641 8.53662C3.19375 8.88918 3.00074 9.3689 3 9.86974V13.9903C3 15.0403 3.81827 15.9145 4.82514 15.9145H5.00647C6.00639 15.9145 6.8207 15.0403 6.8207 13.9903V9.9236C6.8207 6.97183 9.14405 4.5703 12 4.5703C14.856 4.5703 17.1793 6.97183 17.1793 9.9236V13.761C17.181 15.6036 16.2658 17.3165 14.7592 18.2907C14.2069 18.6499 13.5946 18.8987 12.954 19.0242C12.7471 18.7361 12.4297 18.5559 12.0845 18.5303C11.7395 18.5044 11.4006 18.6359 11.1562 18.8902C10.9118 19.1446 10.7859 19.4967 10.8116 19.8549C10.837 20.2131 11.0114 20.5422 11.2893 20.7563C11.5671 20.9705 11.9209 21.0485 12.2588 20.9703C12.5966 20.8922 12.8848 20.6653 13.0486 20.3489C14.0094 20.1849 14.9219 19.7975 15.7179 19.2155C16.5139 18.6335 17.1728 17.8722 17.6451 16.9884C17.8655 16.579 18.0431 16.1464 18.1748 15.6978C18.43 15.8369 18.7132 15.9111 19.0013 15.9142H19.1765C20.1816 15.9142 21 15.0455 21 14.0022V9.86335C20.9985 9.36363 20.8053 8.88516 20.463 8.53368C20.1208 8.18238 19.6577 7.98741 19.1764 7.99132ZM5.54736 13.9902C5.54736 14.3113 5.30447 14.5922 5.00684 14.5922H4.82535C4.52591 14.5922 4.27377 14.3058 4.27377 13.9902V9.86961C4.27422 9.7193 4.3329 9.5756 4.43676 9.47093C4.54061 9.36611 4.68071 9.30929 4.82536 9.31322H5.00684C5.14997 9.31102 5.28809 9.36878 5.38983 9.47345C5.49156 9.57812 5.54826 9.72103 5.54736 9.86961V13.9902ZM19.7264 14.0023C19.7264 14.3166 19.4793 14.5923 19.1765 14.5923H19.0012C18.6984 14.5923 18.4528 14.3167 18.4528 14.0023V9.86348C18.4528 9.54916 18.6984 9.31324 19.0012 9.31324H19.1765C19.4793 9.31324 19.7264 9.54917 19.7264 9.86348V14.0023Z" fill="#004346"/>
        </svg>
    )
}

ProgressTrackerRowsBroadband.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        date: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        description: PropTypes.string,
        stepTitle: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        completed: PropTypes.bool.isRequired,
    })).isRequired,
    serviceDetails: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
    validIdCheck: state.auth.validIdCheck
})

export default connect(mapStateToProps, { getCustomer })(ProgressTrackerRowsBroadband)



// WEBPACK FOOTER //
// ./resources/js/components/ProgressTrackerRowsBroadband.js